import React, { useContext, useEffect, useRef, useState } from 'react';
import secureLocalStorage from 'react-secure-storage';
import { MyContext } from '../../Context/MyProvider';
import ImageLoad from '../ImageLoad';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { showToast } from '../../showTost';

const Profile = () => {

    const { t } = useTranslation();
    const { ApiBaseUrl, ImgBaseUrl, setIsLogin, isLogin } = useContext(MyContext);

    const [profilePic, setProfilePic] = useState("");
    const [data, setData] = useState({ name: '', email: '' });
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [number, setNumber] = useState("");
    const [password, setPassword] = useState("");
    const [countryCode, setCountryCode] = useState("");

    const FileRef = useRef(null);

    useEffect(() => {
        const LoginData = secureLocalStorage.getItem("Loginuser");
        if (LoginData) {
            const { country_code, name, email, phone, image } = JSON.parse(LoginData);
            setCountryCode(country_code);
            setName(name);
            setEmail(email);
            setNumber(phone);
            setProfilePic(ImgBaseUrl + image);
            setData({ name, email });
        }
    }, [isLogin]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        if (!file) return;

        const allowedTypes = ["image/jpeg", "image/png", "image/webp"];

        if (!allowedTypes.includes(file.type)) {
            showToast({ title: t("Only JPG, PNG, WEBP files are allowed!"), id: "error" });
            e.target.value = "";
            return;
        }

        const imageUrl = URL.createObjectURL(file);
        setProfilePic(imageUrl);
    };

    const HandleEditProfile = (e) => {
        e.preventDefault();

        const Userid = secureLocalStorage.getItem("Userid");

        if (!profilePic) {
            showToast({ title: t("Upload Profile Photo"), id: "error" });
            return;
        }

        if (!name || !email || !number) {
            showToast({ title: t("Enter details"), id: "error" });
            return;
        }

        const formData = new FormData();

        formData.append("id", Userid);
        formData.append("image", profilePic);
        formData.append("name", name);
        formData.append("email", email);
        formData.append("password", password ? password : "");
        formData.append("ccode", countryCode);
        formData.append("phone", number);

        axios.post(`${ApiBaseUrl}/customer/edit_profile`, formData)
            .then((res) => {
                console.log(res);
                if (res.data.ResponseCode === 200) {
                    showToast({ title: res.data.message, id: "success" });
                    secureLocalStorage.setItem("Loginuser", JSON.stringify(res.data.customer_detail));
                    setIsLogin("123");
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    return (
        <div className='w-full width-container content-wrapper'>
            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
                <h1 className="text-3xl font-bold text-gray-900 mb-8">{t("My Profile")}</h1>

                <div className="rounded-xl border border-gray-200 bg-white shadow-sm transition-shadow hover:shadow-md">
                    <div className="p-8">
                        <div className="flex items-center gap-4 mb-8">
                            <div className="w-20 h-20 rounded-full flex items-center justify-center relative">
                                {profilePic
                                    ? <ImageLoad src={profilePic} CustomeStyle={"w-[100%] h-[100%] object-cover rounded-full"} alt={"logo"} index={1} />
                                    : <div className="bg-[#F3F4F6] w-[100%] h-[100%] flex items-center justify-center font-[500] text-[20px] rounded-full">
                                        <span className='-mt-[6px]'>{data?.name?.split("")[0]}</span>
                                    </div>}

                                <div className="absolute right-0 bottom-0">
                                    <button onClick={() => FileRef.current.click()} className='w-[25px] h-[25px] bg-black rounded-full border-[2px] border-white flex items-center justify-center p-[3px]'>
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17.0371 11.577C17.1541 11.694 17.1541 11.8849 17.0371 12.0019L8 21H3V16L11.998 6.963C12.115 6.845 12.3051 6.845 12.4231 6.963L17.0371 11.577ZM20.4099 5.81005L18.1899 3.58995C17.4059 2.80595 16.1341 2.80595 15.3501 3.58995L13.4719 5.468C13.3549 5.58501 13.3549 5.77496 13.4719 5.89196L18.1079 10.5279C18.2249 10.6449 18.415 10.6449 18.532 10.5279L20.4099 8.65001C21.1939 7.86601 21.1939 6.59405 20.4099 5.81005Z" fill="white" />
                                        </svg>
                                    </button>
                                </div>

                                <input type="file" accept='image/*' ref={FileRef} className='hidden' onChange={handleFileChange} />

                            </div>
                            <div>
                                <h2 className="text-2xl font-bold text-gray-900">{data?.name}</h2>
                                <p className="text-gray-600">{data?.email}</p>
                            </div>
                        </div>

                        <form onSubmit={HandleEditProfile} className='space-y-6'>
                            <div>
                                <label className="text-[15px] font-medium mb-2 flex items-center gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4" aria-hidden="true">
                                        <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                                        <circle cx="12" cy="7" r="4"></circle>
                                    </svg>
                                    {t("Full Name")}
                                </label>
                                <input className="flex h-11 w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-[15px] shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#4038FF] focus-visible:border-transparent disabled:cursor-not-allowed disabled:opacity-50" required value={name} onChange={(e) => setName(e.target.value)} />
                            </div>
                            <div>
                                <label className="text-[15px] font-medium mb-2 flex items-center gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4" aria-hidden="true"><path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path><rect x="2" y="4" width="20" height="16" rx="2"></rect></svg>
                                    {t("Email Address")}
                                </label>
                                <input className="flex h-11 w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-[15px] shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#4038FF] focus-visible:border-transparent disabled:cursor-not-allowed disabled:opacity-50" required value={email} onChange={(e) => setEmail(e.target.value)} />
                            </div>
                            <div>
                                <label className="text-[15px] font-medium mb-2 flex items-center gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4" aria-hidden="true"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path></svg>
                                    {t("Phone Number")}
                                </label>
                                <input className="flex h-11 w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-[15px] shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#4038FF] focus-visible:border-transparent disabled:cursor-not-allowed disabled:opacity-50" required value={number} onChange={(e) => setNumber(e.target.value)} />
                            </div>
                            <div>
                                <label className="text-[15px] font-medium mb-2 flex items-center gap-2">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M16 8.25H8.75V7C8.75 6.139 9.08905 5.3201 9.69604 4.7041C10.32 4.0891 11.138 3.75 12 3.75C13.485 3.75 14.778 4.75106 15.144 6.18506C15.246 6.58606 15.6599 6.82705 16.0549 6.72705C16.4569 6.62405 16.6999 6.21594 16.5969 5.81494C16.0629 3.71594 14.172 2.25 12 2.25C10.742 2.25 9.55099 2.74204 8.63599 3.64404C7.74199 4.55004 7.25 5.742 7.25 7V8.30396C5.312 8.56096 4.25 9.846 4.25 12V18C4.25 20.418 5.582 21.75 8 21.75H16C18.418 21.75 19.75 20.418 19.75 18V12C19.75 9.582 18.418 8.25 16 8.25ZM18.25 18C18.25 19.577 17.577 20.25 16 20.25H8C6.423 20.25 5.75 19.577 5.75 18V12C5.75 10.423 6.423 9.75 8 9.75H16C17.577 9.75 18.25 10.423 18.25 12V18ZM13.27 14C13.27 14.412 13.058 14.7601 12.75 14.9871V17C12.75 17.414 12.414 17.75 12 17.75C11.586 17.75 11.25 17.414 11.25 17V14.9619C10.962 14.7329 10.7649 14.395 10.7649 14C10.7649 13.31 11.32 12.75 12.01 12.75H12.02C12.71 12.75 13.27 13.31 13.27 14Z" fill="currentColor" />
                                    </svg>
                                    {t("Password")}
                                </label>
                                <input className="flex h-11 w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-[15px] shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#4038FF] focus-visible:border-transparent disabled:cursor-not-allowed disabled:opacity-50" value={password} onChange={(e) => setPassword(e.target.value)} placeholder={t('Enter Password (Optional)')} />
                            </div>

                            <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl text-sm font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 text-white shadow hover:bg-[#4038FF] active:scale-95 px-6 py-2 w-full h-12 bg-[#4038FF]" type="submit">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 mr-2" aria-hidden="true">
                                    <path d="M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"></path>
                                    <path d="M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7"></path>
                                    <path d="M7 3v4a1 1 0 0 0 1 1h7"></path>
                                </svg>
                                {t("Save Changes")}
                            </button>

                        </form>


                    </div>
                </div>

            </div>
        </div>
    )
}

export default Profile